import { Fragment, useContext, useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { QuestionsContext } from '../../context/Questions';
import { AppContext } from '../../context/App-context';
import Menu from '../../components/menu/Menu';
import HttpAxios from '../../hooks/http';
import WizardUser from '../../components/wizard/Wizard-user';
import ProgressBar from '../../components/progressbar/Progressbar';
import { EErrorMsg } from '../../statics/controls';
import { TMenuActions } from '../../interfaces/items';
import IconClose from '../../../images/close.svg';
import IconArrowLeft from '../../../images/arrow-left.svg';
import IconArrowRight from '../../../images/arrow-right.svg';
import './modal-user.scss';

interface IDialog {
    isOpenState?: boolean;
}

const ModalUser = (props: IDialog) => {
    const {
        showModalUser,
        changeShowModalUser,
        userId,
        selectedMenu,
        changeSelectedMenu,
    } = useContext(QuestionsContext);
    const { isLoading, changeIsLoading, changeSnackBar } =
        useContext(AppContext);
    const [questions, setQuestions] = useState<Array<any>>([]);
    const [listMenu, setListMenu] = useState<Array<any>>([]);
    const [dataUser, setDataUser] = useState<any>({});

    const setUser = (cb: Function) => {
        setDataUser({});
        setQuestions([]);
        setListMenu([]);
        changeIsLoading(true);
        HttpAxios.get('/user/' + userId)
            .then((res: any) => {
                const { err, response = [] } = res?.data || {};
                if (err) {
                    changeSnackBar(EErrorMsg.generic);
                    changeIsLoading(false);
                    changeShowModalUser(false);
                } else {
                    setDataUser(response);
                    changeIsLoading(false);
                    cb();
                }
            })
            .catch(() => {
                changeSnackBar(EErrorMsg.generic);
                changeIsLoading(false);
                changeShowModalUser(false);
            });
    };

    const setQuestionsByUser = () => {
        setQuestions([]);
        setListMenu([]);
        changeIsLoading(true);
        HttpAxios.get('/forms/questions/' + userId)
            .then((res: any) => {
                const { err, response = [] } = res?.data || {};
                if (err) {
                    changeSnackBar(EErrorMsg.generic);
                    changeIsLoading(false);
                    changeShowModalUser(false);
                } else {
                    processQuestions(response);
                    changeIsLoading(false);
                }
            })
            .catch(() => {
                changeSnackBar(EErrorMsg.generic);
                changeIsLoading(false);
                changeShowModalUser(false);
            });
    };

    const processQuestions = (q: Array<any>) => {
        setQuestions(q);
        const _menu: Array<any> = q.map((item: any) => ({
            label: item.descripcion || '',
            value: item.idcategoria || '',
        }));
        setListMenu(_menu);
    };

    const controlMenu = (type: TMenuActions) => {
        const item = Number(selectedMenu?.value) - 1;

        if (type === 'prev') {
            changeSelectedMenu(item > 0 ? listMenu[item - 1] : listMenu[0]);
        } else if (type === 'next') {
            changeSelectedMenu(
                item < listMenu.length
                    ? listMenu[item + 1]
                    : listMenu[listMenu.length]
            );
        }
    };

    useEffect(() => {
        userId && setUser(setQuestionsByUser);
    }, [userId]);

    return (
        <>
            <Transition
                show={showModalUser}
                enter="ModalEnter"
                enterFrom="ModalEnterFrom"
                enterTo="ModalEnterTo"
                leave="ModalLeave"
                leaveFrom="ModalLeaveFrom"
                leaveTo="ModalLeaveTo"
            >
                <Dialog
                    className="Modal"
                    onClose={() =>
                        changeShowModalUser(isLoading ? isLoading : false)
                    }
                >
                    <div className="ModalOverlay" />

                    <div className="ModalContent bgLinear">
                        <Dialog.Description as={Fragment}>
                            <div className="ModalDerscription">
                                <div className="ModalProgressBar">
                                    <ProgressBar
                                        progress={
                                            dataUser?.avancepostulacion || 0
                                        }
                                    ></ProgressBar>
                                </div>
                                <Menu items={listMenu}></Menu>
                                <div className="ModalQuestions">
                                    {questions?.length > 0 && (
                                        <WizardUser
                                            questions={questions}
                                            dataUser={dataUser}
                                        ></WizardUser>
                                    )}
                                </div>
                                <div className="ContentNav">
                                    {Number(selectedMenu?.value) > 1 && (
                                        <button
                                            className="button buttonLink"
                                            type="button"
                                            onClick={() => controlMenu('prev')}
                                        >
                                            <img
                                                src={IconArrowLeft}
                                                className="buttonIconLeft"
                                                alt=""
                                            />
                                            <span className="ContentNavButtonText">
                                                Sección Anterior
                                            </span>
                                        </button>
                                    )}
                                    <span className="separate"></span>
                                    {listMenu?.length > 0 &&
                                        Number(selectedMenu?.value) <
                                            listMenu?.length && (
                                            <button
                                                className="button buttonLink"
                                                type="button"
                                                onClick={() =>
                                                    controlMenu('next')
                                                }
                                            >
                                                <span className="ContentNavButtonText">
                                                    Siguiente sección
                                                </span>
                                                <img
                                                    src={IconArrowRight}
                                                    className="buttonIconRight"
                                                    alt=""
                                                />
                                            </button>
                                        )}
                                </div>
                            </div>
                        </Dialog.Description>
                        <button
                            className="ModalClose"
                            onClick={() =>
                                changeShowModalUser(
                                    isLoading ? isLoading : false
                                )
                            }
                        >
                            <img src={IconClose} alt="Close" />
                        </button>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
};

export default ModalUser;
